export enum LegalEntityContactDeletionBlockerType {
    Audit = 1,
    InternalAssessment = 2,
    Contract = 3,
}

export const legalEntityContactBlockerTranslationKeys: Record<LegalEntityContactDeletionBlockerType, string> = {
    [LegalEntityContactDeletionBlockerType.Audit]: "audits",
    [LegalEntityContactDeletionBlockerType.InternalAssessment]: "internalAssessments",
    [LegalEntityContactDeletionBlockerType.Contract]: "contracts",
};
